import React, { Fragment } from "react";
import { compose } from "redux";
import { connect } from "react-redux";
import { Grid } from "@material-ui/core";
import _ from "lodash";
import styled from "styled-components";

import {
  ChildSectionTitle,
  SideLabelTextWithRefInput,
  SideLabelTextAreaWithRefInput,
  SideLabelIntegerWithRefInput,
  SideLabelPercentWithRefInput,
  SideLabelMoneyWithRefInput
} from "../FormSectionComponents";

const ExtensionTermsGrid = styled(Grid)`
  &&& {
    width:1200px;
  }
`;
class ExtensionTermsChildSection extends React.Component {
  render() {
    // hide if not sysadmin
    if (!this.props.authentication.isSystemAdmin) {
      return null;
    }
    const { isEditing, isQuote } = this.props;

    return (
      <div id="loan_section_extension_terms_old">
        <ChildSectionTitle>Extension Terms</ChildSectionTitle>
        <ExtensionTermsGrid container alignItems="center" direction="column">
          <SideLabelIntegerWithRefInput
            label="Extension Options"
            hasBorder
            placeholder="Extension Options"
            fieldName="extensionTerms.extensionOptions"
            isDisabled={!isEditing}
          />
          <SideLabelIntegerWithRefInput
            label="Extension Term (Months)"
            hasBorder
            placeholder="Extension Term (Months)"
            fieldName="extensionTerms.extensionTermMonths"
            isDisabled={!isEditing}
          />
          <SideLabelIntegerWithRefInput
            label="Extensions Remaining"
            hasBorder
            placeholder="Extensions Remaining"
            fieldName="extensionTerms.extensionRemaining"
            isDisabled={!isEditing}
            shouldHideForQuote={isQuote}
          />
          <SideLabelTextAreaWithRefInput
            label="Notice Period"
            hasBorder
            placeholder="Notice Period"
            fieldName="extensionTerms.noticePeriod"
            isDisabled={!isEditing}
          />
          <SideLabelMoneyWithRefInput
            label="Extension Fee ($)"
            hasBorder
            placeholder="Extension Fee ($)"
            fieldName="extensionTerms.extensionFeeAmt"
            refFieldName="extensionTerms.extensionFeeRef"
            isDisabled={!isEditing}
          />
          <SideLabelPercentWithRefInput
            label="Extension Fee (%)"
            hasBorder
            placeholder="Extension Fee (%)"
            fieldName="extensionTerms.extensionFeePercent"
            refFieldName="extensionTerms.extensionFeePercentRef"
            isDisabled={!isEditing}
          />
          <SideLabelTextAreaWithRefInput
            label="Qualifications"
            hasBorder
            placeholder="Qualifications"
            fieldName="extensionTerms.qualifications"
            isDisabled={!isEditing}
          />
          <SideLabelTextAreaWithRefInput
            label="Extension Amortization"
            hasBorder
            placeholder="Extension Amortization"
            fieldName="extensionTerms.extensionAmortization"
            isDisabled={!isEditing}
          />
          <SideLabelPercentWithRefInput
            label="LTV Req."
            hasBorder
            placeholder="LTV Req."
            fieldName="extensionTerms.ltvReq"
            isDisabled={!isEditing}
          />
          <SideLabelTextWithRefInput
            label="DSCR Req."
            hasBorder
            placeholder="DSCR Req."
            fieldName="extensionTerms.dscrReq"
            isDisabled={!isEditing}
          />
          <SideLabelPercentWithRefInput
            hasBorder
            label="Debt Yield Req."
            placeholder="Debt Yield Req."
            fieldName="extensionTerms.debtYieldReq"
            isDisabled={!isEditing}
          />
          <SideLabelTextAreaWithRefInput
            label="Misc."
            placeholder="Misc."
            fieldName="extensionTerms.misc"
            isDisabled={!isEditing}
          />
        </ExtensionTermsGrid>
      </div>
    );
  }
}
function mapStateToProps({ authentication }) {
  return {
    authentication
  };
}

export default compose(
  connect(mapStateToProps, {

  })
)(ExtensionTermsChildSection);
